
<template lang="html">
  <scroll
    :listenScroll="listenScroll"
    :probe-type="scrollProbeType"
    ref="scroll">
    <div class="ter">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in mainProduce" :key="index">
          <img :src="item.bakImg" alt="" class="move">
          <div class="">
            <div class="">
              <div class="">
                <h1>{{item.title}}</h1>
                <p>{{item.intro}}</p>
              </div>
              <div class="btn-box">
                <div class="img-box" v-if="item.qrImg">
                  <img :src="item.qrImg" alt="" @click.stop="previewQr(item.qrImg)">
                  <p v-if="item.qrImg === '#'">维护中...</p>
                </div>
                <div class="">
                  <ul>
                    <li v-for="(inItem, inIndex) in item.typeCt" :key="inIndex">
                      <button type="button" name="button" @click="toZhunei(inItem.typeLink)">{{inItem.name}}</button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination "  slot="pagination"></div>
      </swiper>
      <div class="main">
        <div class="top">
          <h1>产品动态</h1>
        </div>
        <div class="main-content" v-for="(item, index) in produceActive" :key="index" :class="{'pb20': (produceActive.length - 1) === index}">
          <div class="content-imgbox">
            <img v-lazy="item.img" alt="" class="move">
          </div>
          <div class="detail">
            <div class="top-in">
              <h1>{{item.title}}</h1>
              <div class="more" v-show="item.more" @click="toMore(item.more)">
                更多
                <i class="icon iconfont icon-gengduo1"></i>
              </div>
            </div>
            <div class="">
              <ul>
                <li v-for="(inItem, inIndex) in item.content" :key="inIndex">
                  <p>{{inItem.item}}</p>
                  <span>{{inItem.date}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <m-footer></m-footer>
    </div>
  </scroll>
</template>

<script>
import Scroll from 'base/scroll/scroll'
import MFooter from 'components/ter/footer/footer'
import produceData from 'common/ter/js/produce'
// import {navShowMixin} from 'common/js/mixin'
// import 'swiper/dist/css/swiper.css'
// import 'common/stylus/base.styl'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {mapGetters, mapMutations} from 'vuex'
// console.log(produceData)
export default {
  // mixins: [navShowMixin],
  methods: {
    //
    previewQr (url) {
      console.log(url)
      this.setImg(url)
      this.preview(true)
    },
    //
    toZhunei (url) {
      console.log(url)
      if (!url) {
        return
      }
      window.open(url)
    },
    // 更多
    toMore (url) {
      window.open(url)
    },
    ...mapMutations({
      preview: 'SET_IS_SHOW',
      setImg: 'SET_IMG_URL'
    })
  },
  created () {
    this.scrollProbeType = 2
    this.mainProduce = produceData.mainProduce
    this.produceActive = produceData.produceActive
  },
  data () {
    return {
      produceActive: null,
      mainProduce: null,
      listenScroll: true,
      swiperOption: {
        notNextTick: true, // 循环
        loop: true, // 设定初始化时slide的索引
        initialSlide: 0, // 自动播放
        autoplay: true,
        // autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true,
        // },
        // 设置轮播
        // effect: 'flip',
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        // 小手掌抓取滑动
        // grabCursor : true,
        // 滑动之后回调函数
        // on: {
        //   slideChangeTransitionEnd: function () {
        //     // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
        //   }
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // 分页器设置
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide,
    Scroll,
    MFooter
  },
  computed: {
    ...mapGetters(['isShow']),
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import "~common/ter/stylus/media"
.pb20
  padding-bottom: 20px !important
.swiper-slide
  &>img
    width: 100%
    set-height(300)
  &>div
    width: 100%
    position: absolute
    left: 0
    top: 50%
    right: 0
    transform: translateY(-50%)
    margin: auto
    text-align: center
    h1
      font-size: 18px
      color: #fff
    p
      font-size: 12px
      color: #fff
      margin: 7px 0 10px
    .btn-box
      ul
        display: flex
        justify-content: center
        padding-top: 5px
      .img-box
        width: 80px
        height: 80px
        background-color: rgba(255, 255, 255, .3)
        padding: 5px
        margin: auto
        margin-bottom: 10px
        img
          set-width(70)
          set-height(70)
        p
          position: absolute
          left: 50%
          top: 50%
          line-height: 1
          margin: 0
          transform: translate3d(-50%, -50%, 0)
    .exh
      width: 400px
    button
      width: 90px
      height: 35px
      border-radius: 35px
      overflow: hidden
      background-color: rgba(255, 255, 255, 0.8)
      color: #007CE5
      font-size: 12px
      cursor: pointer
      margin: 0 6px
.main
  width: 100%
  background-color: #F5F5F5
  .top
    position: relative
    padding: 20px 18px 10px
    background-color: #fff
    &:after
      content: ''
      width: 4px
      height: 10px
      position: absolute
      left: 10px
      top: 23px
      background-color: #007CE5
    h1
      font-size: 14px
      color: #007CE5
  .main-content
    display: flex
    position: relative
    margin-top: 40px
    padding-bottom: 10px
    background-color: #fff
    .content-imgbox
      flex: 0 0 170px
    img
      width: 170px
      height: 120px
    .detail
      width: calc(100% - 170px)
      ul
        margin-left: 10px
      li
        position: relative
        font-size: 10px
        line-height: 1
        padding: 5px 0
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        p
          width: 100%
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          margin-bottom: 5px
          padding-top: 5px
        span
          font-size: 9px
          color: #999
        &:after
          content: ''
          width: 100%
          height: 1px
          position: absolute
          left: 0
          bottom: 0
          background-color: #ECECEC
      h1
        font-size: 14px
        color: #333
        &>div
          font-size: 10px
      i
       margin-left: 5px
       font-size: 10px
    .top-in
      width: 100%
      position: absolute
      top: -36px
      left: 0
      right: 0
      display: flex
      justify-content: space-between
      align-items: center
      color: #333
      padding: 10px
      .more
        display: flex
        color: #007CE5
        align-items: center
</style>



// WEBPACK FOOTER //
// src/components/ter/produce/produce.vue